export enum RoleType {
  PreBuiltRole = 'Pre-built role',
  CustomRole = 'Custom role',
}
